import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage14.module.css"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/kali.json";

export default function LaymanPage14() {
  return (
    <>
<Common_html BlockData={BlockData} />
    </>
  )
}
